<template>
  <div id="about">
  	<div class="aboutHead">
      <home-header :navName="navName"></home-header>
      <div class="nav_name">关于我们</div>
      <div class="nav_name_info">
        <p>北京星球时空科技有限公司是一家依托中国科学院地理科学与资源研究所和资源与环境信息系统国家重点实验室的高新技术企业，致力于为军队、航空航天、地图出版、应急救灾、智慧城市等特殊行业用户提供时空全息大数据平台产品及解决方案。</p>
      </div>
    </div>
  	<div id="bodyer">
  		<ul class="banner">
          <li :class="{active:bannerActive == 1}" @click="bannerActive = 1"><img src="../../assets/images/about/1.png" alt="">公司简介</li>
          <li :class="{active:bannerActive == 2}" @click="bannerActive = 2"><img src="../../assets/images/about/2.png" alt="">新闻资讯</li>
          <li :class="{active:bannerActive == 3}" @click="bannerActive = 3"><img src="../../assets/images/about/3.png" alt="">人才招聘</li>
          <li :class="{active:bannerActive == 4}" @click="bannerActive = 4"><img src="../../assets/images/about/4.png" alt="">联系我们</li>
      </ul>
      <ul class="ulcontent">
        <li class="jianJie" :class="{active:bannerActive == 1}">
          <h3>我们的优势</h3>
          <ul class="youshi">
            <li>
              <div class="cPic"><img src="../../assets/images/home/c1.png" alt=""></div>
              <div class="cTitle">院士团队，技术引领</div>
              <div class="cContent">
                星球时空由中科院周成虎院士担任首席科学家，核心团队来自中科院、武汉大学、解放军信息工程大学、国内知名互联网地图及测绘地理信息企业的资深专业人士。公司以全息地图理论为指导，在“全空间数据整合、全维度可视表达、全媒介网络印刷、全行业平台应用”方面具有很强的技术创新能力和丰富的工程实践经验。
              </div>
            </li>
            <li>
              <div class="cPic"><img src="../../assets/images/home/c2.png" alt=""></div>
              <div class="cTitle">丰富数据，海量地图</div>
              <div class="cContent">
                时空全息大数据平台可容纳海量地图数据资源，包括全球多时相高分辨率影像（上千亿瓦片、两个时相超560T）、百万幅级专题图、100PB遥感卫星资源数据（商业/公开/专线卫星资源）以及超过50GB的海量基础数据（全国路网、地名、政区、DEM）和丰富的专题数据（人口普查、环境统计、地理区划、历史文化）
              </div>
            </li>
            <li>
              <div class="cPic"><img src="../../assets/images/home/c3.png" alt=""></div>
              <div class="cTitle">自主可控，质量过硬</div>
              <div class="cContent">
                自主研制网络地图服务器整机系统，采用高性能高强度国产元部件、定制操作系统，通过硬件加密卡、预置安全策略、军工级数据加密算法、统一用户认证及分级权限控制等手段确保信息安全，保障系统运行稳定。
              </div>
            </li>
            <li>
              <div class="cPic"><img src="../../assets/images/home/c4.png" alt=""></div>
              <div class="cTitle">应急保障，快速响应</div>
              <div class="cContent">
                依托自主研发的“地图工厂”软件和地图全媒介印刷技术，提供全息地图编制与出版（发布）在内容、技术和渠道三个方面的深度融合服务，实现应急场景特殊地图、时空专题数据等全息地图的一次制作、多元出版、快速响应、全媒介按需印刷。
              </div>
            </li>
          </ul>
          <div class="abTop"><img src="../../assets/images/home/abTop.png" @click="rTop"></div>
        </li>
        <li class="news" :class="{active:bannerActive == 2}" v-for="newsdata in newsdatas">
          <div class="date">
            <p class="tian"></p>
            <p class="yue"></p>
          </div>
          <div class="newsContent">
            <div class="title"></div>
            <div class="content"></div>
            <div class="detailA">
              <div class="Dtitle"></div><button>< 返回</button>
              <div class="time"><span class="year"></span>-<span class="month"></span>-<span class="day"></span></div>
              <div class="detailC"></div>
            </div>

          </div>
        </li>
        <li class="job" :class="{active:bannerActive == 3}" v-for="jobdata in jobdatas">
          <!-- <div class="jobMess">职位信息</div> -->
          <div class="img"><div class="title"></div><img src="../../assets/images/about/down.png" class="down"><img src="../../assets/images/about/up.png" class="up"></div>
          <div class="message"></div>
        </li>
        <li class="lx" :class="{active:bannerActive == 4}">
          <div class="lTitle">联系方式</div>
          <h3>北京星球时空科技有限公司</h3>
          <p class="addr">地址：北京市海淀区花园北路14号66幢2层226号</p>
          <p class="yb">邮编：213022</p>
          <p class="phon">电话：010-52861878</p>
          <p class="eml">邮箱：public@mapscloud.cn</p>
          <img src="../../assets/images/about/map.png" alt="">
        </li>
        <li :class="{active:bannerActive == 5}" class="detail">
          <div class="detailTitle"></div>
          <div class="detailContent"></div>
        </li>
      </ul>
  	</div>
    <connect-part></connect-part>
    <home-footer></home-footer>
  </div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './header'
import ConnectPart from './connect'
import HomeFooter from './footer'
export default {
  name: 'facilityCloud',
  components:{
  	HomeHeader:HomeHeader,
    ConnectPart:ConnectPart,
    HomeFooter:HomeFooter
  },
  data: function() {
  		return {
  			listdata:"",
  			navName:"about",
        bannerActive: 1,
        aboutList:[["about_news"],["about_job"],["about_contact_us"]],
        newsdatas:[],
        jobdatas:[]
  		}
  },
  methods:{
  	getGcmsList:function(){
      var that = this;
      var aboutList = that.aboutList;
      for(var i=0;i<aboutList.length;i++){
        ((function(i){
          // axios.get(xdc_app_config.gcms_server+'/content/'+aboutList[i]).then(this.getLength)
          var url = xdc_app_config.gcms_server+'/content/'+aboutList[i];
          $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
          })
          .done(function(data) {
            // console.log(data);
            // var length = data.total;
            var aboutData = data.data;
            // if(length >= 0){
              $(aboutData).each(function(j,item){
                var innerUrl = xdc_app_config.gcms_server+'/content/'+aboutList[i]+'/'+item.gcms_id;
                $.ajax({
                  url: innerUrl,
                  type: 'GET',
                  dataType: 'json'
                })
                .done(function(data) {
                  // console.log(data);
                  if(data.data){
                    that.updateData(data.data,aboutList[i])
                  }
                })
                .fail(function() {
                  // console.log("error");
                })
              })
            // }
          })
          .fail(function() {
            // console.log("error");
          })
        }(i)))
      }
  	},
  	updateData:function(data,activeAbout){
      var that = this;
      var aboutData = data;
      var options = {};
      if(aboutData && activeAbout == "about_news"){
        // console.log("news");
        // console.log(aboutData);
        options.gcms_title = aboutData.gcms_title;
        options.introduction = aboutData.introduction;
        options.content = aboutData.content;
        var date = new Date(aboutData.time);
        options.year = 1900 + date.getYear();
        var m = "0"+(date.getMonth()+1);
        options.month = m.substring(m.length-2,m.length);
        var d = "0"+date.getDate();
        options.day = d.substring(d.length-2,d.length);

        that.unique5(that.newsdatas);
        that.newsdatas.push(options);
        // console.log(options);
        setTimeout(function(){
          that.showDetail();
        },500)

      } else if(aboutData && activeAbout == "about_job"){
        options.gcms_title = aboutData.gcms_title;
        options.content = aboutData.content;


        that.unique5(that.jobdatas);
        that.jobdatas.push(options);
      }
      that.fixJob();
  	},
    showDetail:function(){
      var that = this;
      for(var i=0;i<that.newsdatas.length;i++){
        $(".news .tian").eq(i).html(that.newsdatas[i].day);
        $(".news .day").eq(i).html(that.newsdatas[i].day);
        $(".news .yue").eq(i).html(that.newsdatas[i].month);
        $(".news .month").eq(i).html(that.newsdatas[i].month);
        $(".news .year").eq(i).html(that.newsdatas[i].year);
        $(".news .title").eq(i).html(that.newsdatas[i].gcms_title);
        $(".news .Dtitle").eq(i).html(that.newsdatas[i].gcms_title);
        $(".news .content").eq(i).html(that.newsdatas[i].introduction);
        $(".news .detailC").eq(i).html(that.newsdatas[i].content);

      }
      $(".news .title").bind("click",function(){
        var index = $(this).parent().parent().index();
        $(this).parent().find(".detailA").show();
        $(this).parent().find(".detailA").css("top",-130*index+"px")
        $(".news .title,.news .content,.news .date").hide();
      })
      $(".ulcontent .detailA button").bind("click",function(){
        $(this).parent().hide();
        $(".news .title,.news .content,.news .date").show();
      })
    },
    fixJob: function(){
      // var jobM = $("<div class="jobMess">职位信息</div>");
      // $(".job").push(jobM)
      var that = this;
      for(var i=0;i<that.jobdatas.length;i++){
        $(".job .title").eq(i).html(that.jobdatas[i].gcms_title)
        $(".job .message").eq(i).html(that.jobdatas[i].content)
      }
      $(".job .message").eq(0).addClass('active');
      $(".job .img").unbind("click").bind("click",function(){
        var par = $(this);
        var mes = $(this).next();
        if(mes.hasClass('active')){
          mes.removeClass('active')
          par.find(".down").show();
          par.find(".up").hide();
        } else{
          mes.addClass('active')
          par.find(".down").hide();
          par.find(".up").show();
        }
      })
    },
    unique5: function(array){
      var r = [];
      for(var i = 0, l = array.length; i < l; i++) {
       for(var j = i + 1; j < l; j++)
        if (array[i] === array[j]) j = ++i;
       r.push(array[i]);
       }
       return r;
    },
    loadXMLString:function(txt){
        try //Internet Explorer
          {
              xmlDoc=new ActiveXObject("Microsoft.XMLDOM");
              xmlDoc.async="false";
              xmlDoc.loadXML(txt);
              //alert('IE');
              return(xmlDoc);
          }
        catch(e)
          {
              try //Firefox, Mozilla, Opera, etc.
                {
                    parser=new DOMParser();
                    xmlDoc=parser.parseFromString(txt,"text/xml");
                 //alert('FMO');
                    return(xmlDoc);
                }
              catch(e) {alert(e.message)}
          }
        return(null);
    },
    rTop: function(){
      window.scroll(0,0);
    }　
  },
  mounted:function(){
  	this.getGcmsList();
    $(window).scroll(function(event){
      if(window.scrollY > 300){
        $(".aboutHead #header").css("background","#4b5768");
      }else if(window.scrollY <= 300){
        $(".aboutHead #header").css("background","none");
      }
    });
    if(this.bannerActive == 4){
      $(".jf").click();
    }
    if(this.bannerActive == 1){
      $(".jianjie").addClass('active');
    }
  }
}
</script>
<style scoped>
@import "../../assets/styles/about.css";
</style>



// WEBPACK FOOTER //
// src/pages/components/about.vue